import script from "./Aadhaar-card-design.vue?vue&type=script&setup=true&lang=js"
export * from "./Aadhaar-card-design.vue?vue&type=script&setup=true&lang=js"

import "./Aadhaar-card-design.vue?vue&type=style&index=0&id=4f7766e0&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4f7766e0"]])

export default __exports__